import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '../actions/global';
import * as actions from '../actions/taxLimitation';

const initialState = fromJS({
  taxLimitations: { data: [], state: null },
  compressRuns: { data: [], state: null },
  compressRunProperties: { data: [], totalRecords: 0, state: null },
  hitlRuns: { data: [], state: null },
  hitlRunProperties: { data: [], totalRecords: 0, state: null },
});

const TaxLimitationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_TAX_LIMITATIONS[START]: {
      return state.setIn(['taxLimitations', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_TAX_LIMITATIONS[SUCCESS]: {
      return state
        .setIn(['taxLimitations', 'state'], fetchingState.LOADED)
        .setIn(
          ['taxLimitations', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_TAX_LIMITATIONS[ERROR]: {
      return state.setIn(['taxLimitations', 'state'], fetchingState.ERROR);
    }

    case actions.FETCH_TAX_LIMITATION_COMPRESS_RUNS[START]: {
      return state.setIn(['compressRuns', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_TAX_LIMITATION_COMPRESS_RUNS[SUCCESS]: {
      return state
        .setIn(['compressRuns', 'state'], fetchingState.LOADED)
        .setIn(
          ['compressRuns', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_TAX_LIMITATION_COMPRESS_RUNS[ERROR]: {
      return state.setIn(['compressRuns', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_COMPRESS_RUN_PROPERTIES[START]: {
      return state.setIn(
        ['compressRunProperties', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_COMPRESS_RUN_PROPERTIES[SUCCESS]: {
      return state
        .setIn(['compressRunProperties', 'state'], fetchingState.LOADED)
        .setIn(
          ['compressRunProperties', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['compressRunProperties', 'totalRecords'],
          fromJS(action.data ? action.data.propertyCount : 0),
        );
    }
    case actions.FETCH_COMPRESS_RUN_PROPERTIES[ERROR]: {
      return state.setIn(
        ['compressRunProperties', 'state'],
        fetchingState.ERROR,
      );
    }

    case actions.FETCH_TAX_LIMITATION_HITL_RUNS[START]: {
      return state.setIn(['hitlRuns', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_TAX_LIMITATION_HITL_RUNS[SUCCESS]: {
      return state
        .setIn(['hitlRuns', 'state'], fetchingState.LOADED)
        .setIn(
          ['hitlRuns', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case actions.FETCH_TAX_LIMITATION_HITL_RUNS[ERROR]: {
      return state.setIn(['hitlRuns', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES[START]: {
      return state.setIn(
        ['hitlRunProperties', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES[SUCCESS]: {
      return state
        .setIn(['hitlRunProperties', 'state'], fetchingState.LOADED)
        .setIn(
          ['hitlRunProperties', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['hitlRunProperties', 'totalRecords'],
          fromJS(action.data ? action.data.propertyCount : 0),
        );
    }
    case actions.FETCH_TAX_LIMITATION_HITL_RUN_PROPERTIES[ERROR]: {
      return state.setIn(['hitlRunProperties', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default TaxLimitationReducer;
